import React from 'react';
import PropTypes from 'prop-types';
import FormTableToolbar from './FormTableToolbar';
import FormTableButton from './FormTableButton';

const FormTablePagination = ({ index, limit, size, setPage }) => {
  const getPage = () => {
    return (index === 0 ? 1 : index / limit + 1) - 1;
  };

  const getPageSize = () => {
    return Math.floor(size / limit) + Math.sign(size % limit);
  };

  const jumpToFirst = () => {
    setPage(0);
  };

  const jumpToLast = () => {
    setPage((getPageSize() - 1) * limit);
  };

  const next = () => {
    setPage((getPage() + 1) * limit);
  };

  const previous = () => {
    setPage((getPage() - 1) * limit);
  };

  const isLastPage = getPage() === getPageSize() - 1;
  const isFirstPage = getPage() === 0;

  return (
    <FormTableToolbar className="pagination">
      <FormTableButton disabled={isFirstPage} title="Goto First" onClick={jumpToFirst}>
        <i className="zmdi zmdi-fast-rewind" />
      </FormTableButton>
      <FormTableButton disabled={isFirstPage} title="Previous Page" onClick={previous}>
        <i className="zmdi zmdi-chevron-left" />
      </FormTableButton>
      <FormTableButton className="title" title="Current Page">
        {getPage() + 1}
      </FormTableButton>
      <FormTableButton disabled={isLastPage} title="Next Page" onClick={next}>
        <i className="zmdi zmdi-chevron-right" />
      </FormTableButton>
      <FormTableButton disabled={isLastPage} title="Goto Last" onClick={jumpToLast}>
        <i className="zmdi zmdi-fast-forward" />
      </FormTableButton>
    </FormTableToolbar>
  );
};

FormTablePagination.defaultProps = {
  index: 0,
  limit: 10,
  setPage: () => {},
  size: 0,
};

FormTablePagination.propTypes = {
  index: PropTypes.number,
  limit: PropTypes.number,
  setPage: PropTypes.func,
  size: PropTypes.number,
};

export default FormTablePagination;
